import axios from 'axios';
import config from './config';

// Axios can be exposed as either the default export or a namespace object under
// Jest/Babel depending on transpilation. Normalize that shape before creating
// the shared instance so all frontend modules and tests behave consistently.
const axiosClient = axios && typeof axios.create === 'function' ? axios : axios.default || axios;

// Centralized axios instance used across the frontend. Tests can mock this
// module or the axios default export. Base URL comes from `config.API_URL` so
// runtime builds use REACT_APP_API_URL and development falls back to localhost.
const api = axiosClient.create({ baseURL: config.API_URL });

export default api;
